import makeStyles from '@mui/styles/makeStyles'

const bp = 710

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: '0.5rem',
    boxSizing: 'border-box',
    borderRadius: '0.75rem',
    width: '100%',
    boxShadow: '0 4px 10px 0 rgba(0, 0, 0, 0.35)',
    padding: '0.5rem',
    background: 'white',
    fontSize: theme.size.sm,

    '&:last-child': {
      marginBottom: '0'
    }
  },

  deleteIcon: {
    marginRight: '0.5rem',
    color: theme.palette.primary.main,
    cursor: 'pointer'
  },

  grid: {
    flex: 1,
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',

    [theme.breakpoints.down(bp)]: {
      gridTemplateColumns: '1fr'
    }
  },

  data: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 0,
    marginBottom: 0,
    width: 'fit-content',
    minHeight: '33px'
  },

  dataTitle: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '0.5rem',
    whiteSpace: 'nowrap',
    color: theme.palette.textLight,
    fontSize: theme.size.sm
  }
}))

export default useStyles
